<template>
  <div>
    <az-panel>
      <template slot="lft">
        <el-button type="primary" size="medium"
          @click="$refs['projectFormBar'].$emit('open')">
          <i class="azappfont az-app-create btn-lft-icon"></i>创建项目
        </el-button>
        <az-button type="refresh" size="medium" :infoNotShow="true"
          @click.native="renderList"></az-button>
      </template>
      <template slot="rt">
        <az-search @search="searchHandler"
          placeholder="请输入项目名称"
          :initValue="pageInfo.company_name">
        </az-search>
      </template>
    </az-panel>
    <el-table
      :data="tableList"
      ref="orderList"
      stripe
      size="small"
      style="width: 100%;">
      <el-table-column
        prop="name"
        label="项目名称">
      </el-table-column>
      <el-table-column
        prop="name"
        label="项目创建者">
        <template slot-scope="scope">
          <span>{{scope.row.add_user_info?scope.row.add_user_info.name:'--/--'}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="leader_user_open_id"
        label="项目负责人">
        <template slot-scope="scope">
          <span>{{scope.row.leader_user_open_info?scope.row.leader_user_open_info.name:'--/--'}}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="company_id"
        label="相关企业">
        <template slot-scope="scope">
          <span>{{scope.row.company_info?scope.row.company_info.name:''}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="contact_name"
        label="项目联系人">
      </el-table-column>
      <el-table-column
        prop="contact_phone"
        label="联系人电话">
      </el-table-column>
      <el-table-column
        prop="contact_position"
        label="联系人职位">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注信息">
      </el-table-column>
      <el-table-column
        align="right"
        width="160"
        label="操作">
        <template slot-scope="scope">
          <az-button size="mini" type="edit" content="编辑项目"
            @click.native="editHandler(scope.row)"></az-button>
          <!-- <az-button size="mini" type="delete-primary"
            content="删除项目"
            @click.native="deleteHandler(scope.row.id)">
          </az-button> -->
        </template>
      </el-table-column>
      <template slot="empty">
        <az-loading v-if="isLoading"></az-loading>
        <div v-else>暂无数据</div>
      </template>
    </el-table>
    <div class="az-pagination clearfix">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        :page-sizes="[10, 20, 30, 40]"
        @size-change="resetPageGoPage"
        @current-change="goPage"
        :current-page.sync="pageInfo.page"
        :page-size.sync="pageInfo.per_page"
        :total="total"></el-pagination>
    </div>
    <customer-form ref="projectFormBar" @refresh="renderList"></customer-form>
  </div>
</template>
<script>
import azButton from '@/base/azButton.vue';
import azSearch from '@/base/azSearch.vue';
// import orgCardDialog from   './orgCardDialog';
import { openConfirmModal } from '@/base/azConfirm/index.js';
// import { getOrgList, deleteOrg } from '@/api/org-manage';
// import { CancelToken, isCancel } from 'axios';
// import { extract422Message } from '@/utils/utils';
import dayjs from 'dayjs';
import customerForm from './customerForm.vue';
// import {create} from './createOrEditCustomer'
import { getProjects, deleteProject } from '@/api/project'

export default {
  name: 'customerList',
  components: {
    azButton,
    azSearch,
    customerForm
    // orgCardDialog
  },
  data() {
    return {
      tableList: [],
      options: [],
      checkeds: [],
      isLoading: true,
      cancel: null,
      keyword: '',
      total: 0,
      pageInfo: {
        page: 1,
        per_page: 10,
        company_name: ''
      },
      groupList: [
        {
          id: '',
          name: '所有分组'
        }
      ]
    }
  },
  methods: {
    resetPageGoPage() {
      this.pageInfo.page = 1;
      this.goPage();
    },

    handleSelectionChange(checkeds) {
      this.checkeds = checkeds;
    },

    editHandler(row) {
      this.$refs['projectFormBar'].$emit('open', row);
    },

    toCancel() {
      if (this.cancel) {
        this.cancel();
      }
    },

    initParams(route) {
      this.pageInfo.page = route.query.page - 0 || 1;
      this.pageInfo.per_page = route.query.per_page - 0 || 10;
      this.pageInfo.company_name = route.query.company_name || '';
    },

    renderList() {
      this.tableList = [];
      this.isLoading = true;
      this.toCancel();

      getProjects({
        ...this.pageInfo
      }).then(res => {
        if (res.code != 0) return;
        this.tableList = res.data?.items || [];
        this.total = res.data?.total || 0;
      }).finally(() => {
        this.isLoading = false;
      })
    },
    goPage() {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.pageInfo,
          __: dayjs().valueOf()
        }
      });
    },
    handleModify(row) {
      this.$refs['orgCardDialogRef'].$emit('edit');
    },
    searchHandler(val) {
      this.pageInfo.company_name = val;
      this.resetPageGoPage();
    },
    deleteHandler(customerId) {
      const beforeClose = (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '删除中...';
          deleteProject(customerId).then(res => {
            if (res.code != 0) throw new Error(res.message);
            this.dialogVisible = false;
            this.$message.success('项目删除成功~！');
            done();
            this.renderList();
          }).catch(err => {
            this.$message.error(err.response && err.response.data ? err.response.data.message : err.message);
          }).finally(() => {
            instance.confirmButtonLoading = false;
          })
        } else {
          done();
        }
      };

      openConfirmModal(this, {
        title: '删除提示',
        txt: '您确定要删除所选项目吗？',
        type: 'danger',
        beforeClose: beforeClose
      }).then(action => {
        console.log('1')
      }).catch(err => {
        console.log(err);
      }).finally(() => {
      });
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.initParams(to);
    this.renderList();
    next();
  },

  created() {
    this.initParams(this.$route);
    this.renderList();
  }
}
</script>